import { CSSProperties } from "react";
import { getStyle } from "@app/shared/icons/utils";
import { IconStorage } from "@app/shared/icons/interfaces";

export const archive: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M8.344-5.14A.5.5 0 0 0 8.5-5.5a.46.46 0 0 0-.156-.344A.46.46 0 0 0 8-6H6a.5.5 0 0 0-.36.156.47.47 0 0 0-.14.344q0 .206.14.36Q5.795-5 6-5h2q.201 0 .344-.14M13-7V.5c0 .133-.055.25-.156.344A.46.46 0 0 1 12.5 1h-11a.5.5 0 0 1-.36-.156A.47.47 0 0 1 1 .5V-7q0-.201.14-.344A.5.5 0 0 1 1.5-7.5h11c.133 0 .25.055.344.156.101.094.156.211.156.344m.5-3.5v2a.5.5 0 0 1-.156.36A.47.47 0 0 1 13-8H1a.52.52 0 0 1-.36-.14.52.52 0 0 1-.14-.36v-2q0-.201.14-.344A.5.5 0 0 1 1-11h12c.133 0 .25.055.344.156.101.094.156.211.156.344m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(-.5 11)"
    />
  ),
  svgProps: {
    height: "12",
    width: "13",
  }
};